import React, { useState, useEffect } from "react";
import "./WebServicePage.css";
import BASE_URL from "../apiConfig";
import useRecaptcha from "../hooks/useRecaptcha";

import heroImg from "../images/webserive.jpg";

/* Images */
import fakegold from "../images/security.jpg";
import auction from "../images/auction.jpg";
import arbitration from "../images/analytics.jpg";
import crm from "../images/feature1-kml.jpg";
import auditor from "../images/feature4.jpg";
import onlineLoan from "../images/mobile.jpg";
import verification from "../images/feature5.png";
import faceVerify from "../images/feature6.jpg";
import payment from "../images/laptop.png";

function WebServicePage() {

    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [widgetId, setWidgetId] = useState(null);
    const { getResponse } = useRecaptcha();

    useEffect(() => {
        if (window.grecaptcha) {
            const container = document.getElementById("recaptcha-webservice");
            if (container && container.innerHTML === "") {
                try {
                    const id = window.grecaptcha.render(container, {
                        // sitekey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
                         sitekey: window.RECAPTCHA_SITE_KEY,
                    });
                    setWidgetId(id);
                } catch (err) {
                    console.error("reCAPTCHA WebServicePage render error:", err);
                }
            }
        }
    }, []);

    const [formData, setFormData] = useState({
        full_name: "",
        phone: "",
        email: "",
        organization: "",
        challenges: ""
    });

    const handleChange = e => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.full_name || !formData.phone) {
            setMessage("❌ Name & Phone Required");
            return;
        }

        setLoading(true);

        try {

            const token = getResponse(widgetId);
            if (!token) {
                setMessage("❌ Please complete the reCAPTCHA");
                setLoading(false);
                return;
            }
            const fd = new FormData();
            Object.keys(formData).forEach(k => fd.append(k, formData[k]));
            fd.append("_type", "webservice_demo");
            fd.append("tk", token);

            const res = await fetch(
                BASE_URL + "/DemoApi/saveData",
                { method: "POST", body: fd }
            );

            const result = await res.json();

            if (result.status) {
                setMessage("✅ Demo Request Submitted");
                setFormData({
                    full_name: "",
                    phone: "",
                    email: "",
                    organization: "",
                    challenges: ""
                });
            } else {
                setMessage("❌ " + (result.message || "Verification Failed"));
            }

        } catch (err) {
            console.error("Submission Error:", err);
            setMessage("❌ Submission Failed. Check Console.");
        }

        setLoading(false);
    };


    /* ================= DATA ================= */

    const modules = [

        {
            title: "Fake Gold Case Detection",
            image: fakegold,
            features: [
                "AI-Powered Analysis – Machine learning models trained on purity patterns",
                "Weight-Density Verification – Cross-check declared vs. actual density",
                // "Image Recognition – Spot hallmark inconsistencies",
                // "Historical Pattern Matching – Flag repeat cases",
                "Instant Alerts – Real-time notifications",
                "Reporting Dashboard – Fraud analytics tracking"
            ]
        },

        {
            title: "Auction Management",
            image: auction,
            features: [
                "Online Auction Portal – Digital bidding platform",
                "Auction Calendar Management",
                "Bidder Registration with KYC",
                "Real-time Bidding Interface",
                // "Automated SARFAESI Notices",
                "Settlement Processing",
                "Surplus Return Tracking",
                "Deficient collection Tracking"
            ]
        },

        {
            title: "Arbitration Management",
            image: arbitration,
            features: [
                "Case Registration with uploads",
                "Hearing Calendar Tracking",
                "Secure Document Repository",
                "Award Tracking",
                "Compliance Monitoring",
                "Legal Audit Trail"
            ]
        },

        {
            title: "CRM Module",
            image: crm,
            features: [
                "360° Customer View",
                "Communication Log Tracking",
                "Customer Segmentation",
                "Campaign Management",
                "Loyalty Program Management"
            ]
        },

        {
            title: "Auditor Module",
            image: auditor,
            features: [
                "Remote Audit Access",
                "Audit Trail Viewer",
                "Compliance Checklist",
                "Custom Audit Report Generation"
            ]
        },

        {
            title: "Online Gold Loan Services",
            image: onlineLoan,
            features: [
                "Virtual Gold Appraisal",
                "Online Loan Application",
                "Video KYC",
                "e-Agreement",
                "Doorstep Service Request"
            ]
        },

        {
            title: "Customer ID Verification",
            image: verification,
            features: [
                "Aadhaar Verification",
                "PAN Validation",
                "Bank Verification",
                "Passport Verification",
                "Customer ID Verification",
                "Face Match Technology",
                "Driving License Screening",
                "GST Verification",
                "Mobile 360 + Credit Score Report"
            ]
        },

        {
            title: "Face Image Verification",
            image: faceVerify,
            features: [
                "AI Face Detection",
                "Biometric Authentication",
                "Multiple Angle Capture",
                "Database Matching"
            ]
        },

        {
            title: "Online Payment Collection",
            image: payment,
            features: [
                "Multi-Gateway Integration",
                "Payment Link Generation",
                "Automated Reconciliation"
            ]
        }

    ];

    return (
        <>

            {/* HERO */}

            <div
                className="webservice-hero"
                style={{ backgroundImage: `url(${heroImg})` }}
            >

                <div className="webservice-wrapper">

                    <div className="webservice-left">

                        <h1>Online Web Service Modules</h1>

                        <h3>
                            Complete Digital Ecosystem for Secure Financial Operations
                        </h3>

                        <p>
                            AI-driven web services enabling verification,
                            auction automation, compliance,
                            payments and digital customer engagement.
                        </p>

                    </div>

                    <div className="webservice-right">

                        <form className="demo-form-web" onSubmit={handleSubmit}>

                            <input name="full_name"
                                placeholder="Full Name*"
                                value={formData.full_name}
                                onChange={handleChange}
                            />

                            <input name="phone"
                                placeholder="Phone Number*"
                                value={formData.phone}
                                onChange={handleChange}
                            />

                            <input name="email"
                                placeholder="Email"
                                value={formData.email}
                                onChange={handleChange}
                            />

                            <input name="organization"
                                placeholder="Organization"
                                value={formData.organization}
                                onChange={handleChange}
                            />

                            <textarea
                                name="challenges"
                                placeholder="Business requirements"
                                value={formData.challenges}
                                onChange={handleChange}
                            />

                            <div
                                id="recaptcha-webservice"
                                style={{ marginBottom: "15px" }}
                            ></div>

                            <button disabled={loading}>
                                {loading ? "Submitting..." : "Book Demo"}
                            </button>

                            {message && <p>{message}</p>}

                        </form>

                    </div>
                </div>
            </div>


            {/* MODULE FLOW */}

            <div className="webservice-enterprise">

                {modules.map((mod, i) => (
                    <div
                        className={`web-row ${i % 2 !== 0 ? "reverse" : ""}`}
                        key={i}
                    >

                        <div className="web-image">
                            <img src={mod.image} alt="" />
                        </div>

                        <div className="web-content">

                            <h2>{mod.title}</h2>

                            <ul>
                                {mod.features.map((f, idx) => (
                                    <li key={idx}>{f}</li>
                                ))}
                            </ul>

                        </div>

                    </div>
                ))}

            </div>
            {/* ================= FINAL ENTERPRISE SECTION ================= */}

            <div className="web-final-section">

                <h2 className="web-final-title">
                    Enterprise Integrations & Security Framework
                </h2>

                <div className="web-final-grid">

                    {/* INTEGRATIONS */}
                    <div className="web-final-card">

                        <h3>Third-Party Integrations</h3>

                        <ul>
                            <li>Credit Bureaus – CIBIL, Experian, Equifax</li>
                            <li>Payment Gateways – Major Indian Providers</li>
                            <li>Government Portals – Aadhaar, PAN, GSTN, NSDL</li>
                            <li>Communication Platforms – WhatsApp, SMS & Email Services</li>
                        </ul>

                    </div>


                    {/* SECURITY */}
                    <div className="web-final-card">

                        <h3>Security Features</h3>

                        <ul>
                            <li>End-to-End Encryption – Secure data transmission</li>
                            <li>2FA & Biometric Login – Multi-factor authentication</li>
                            <li>API Security – OAuth 2.0 & token authentication</li>
                            <li>Data Masking – Sensitive information protection</li>
                            <li>Audit Logs – Complete API call tracking</li>
                        </ul>

                    </div>

                </div>

            </div>

        </>
    );
}

export default WebServicePage;